import React from 'react';

const NotFound = () => {
    return (
      <div className="container">
        <div className="main_content">
          <div className="toptitle">
            {/* <h2 className="d-flex justify-content-center bold-text">
              404 Page Not Found
            </h2> */}
            <div className='breacrubox'></div>
            </div>
            <div className="min-hgt-450 text-center" >
					<h2>Oops!</h2><h3> The page you are looking is not found.</h3>
				</div>
          </div>
        
      </div>
    );
}

export default NotFound